export default __webpack_public_path__ + "static/media/icon-info-participation-fees-1.7164f053.svg";